export const UI_updateInJourneyQuitFlagReducer = {
  UI_updateInJourneyQuitFlag: (state, action) => {
    state.inJourneyQuitModalOpen = action.payload;
  },
};
